// extracted by mini-css-extract-plugin
module.exports = {"tab":"MasterVoucherAssignment_tab__1sreS","assignTable":"MasterVoucherAssignment_assignTable__2rjOz"};